<template>
  <div class="air_monitoring">
    <v-speed-dial
      v-model="fab"
      top
      right
      direction="bottom"
      :open-on-hover="hover"
      :transition="transition"
      class="mr-5"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="cyan darken-1" dark >
          <template v-if="fab">
            <v-icon>
              mdi-menu-up
            </v-icon>
          </template>
          <template v-else>
            <v-icon>
              mdi-menu-down
            </v-icon>
          </template>
            {{ $t("experiment.fab.reference") }}
        </v-btn>
      </template>
      <template>
        <v-btn dark color="indigo" @click="openLabManualDialog();getLabManual()">
          <v-icon>mdi-file-document</v-icon>
          {{ $t("experiment.fab.lab_manual") }}
        </v-btn>
      </template>
      <template>
        <v-btn  dark color="green"  @click="openSetupDialog(); getSetupPhoto()">
          <v-icon> mdi-image-search </v-icon>
          {{ $t("experiment.fab.setup_photo") }}
        </v-btn>
      </template>
      <!--template>
        <v-btn dark color="brown darken-1" @click="getLabManual">
          <v-icon>mdi-play-circle</v-icon>
          {{ $t("experiment.fab.video_demo") }}
        </v-btn>
      </template-->
    </v-speed-dial>
    <v-row>
      <v-col xs="12" sm="4">
        <v-expansion-panels v-model="controlPanel" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>Real-time Values</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-card>
                <v-card-text>
                  <v-row class="ml-1 mr-1">
                    <v-col xs="12">
                      <h5 v-if='battery==0' class='grey--text text--darken-3'>
                        <v-icon class='grey--text text--darken-3'>mdi-battery-off-outline</v-icon>
                        <b> {{ battery }} % </b>
                        <small v-if='current_ma<0' class='grey--text text--darken-3'>(Discharging)</small>
                        <small v-else-if='current_ma>0' class='grey--text text--darken-3'>(Charging)</small>
                      </h5>
                      <h5 v-else-if='battery<=15' class='red--text'>
                        <v-icon class='red--text'>mdi-battery-10</v-icon>
                        <b> {{ battery }} % , low battery, please charge </b>
                        <small v-if='current_ma<0' class='grey--text text--darken-3'>(Discharging)</small>
                        <small v-else-if='current_ma>0' class='grey--text text--darken-3'>(Charging)</small>
                      </h5>
                      <h5 v-else-if='battery<=30' class='orange--text text--darken-1'>
                        <v-icon class='orange--text text--darken-1'>mdi-battery-30</v-icon>
                        <b> {{ battery }} % </b>
                        <small v-if='current_ma<0' class='grey--text text--darken-3'>(Discharging)</small>
                        <small v-else-if='current_ma>0' class='grey--text text--darken-3'>(Charging)</small>
                      </h5>
                      <h5 v-else-if='battery<=50' class='yellow--text text--darken-1'>
                        <v-icon class='yellow--text text--darken-1'>mdi-battery-50</v-icon>
                        <b> {{ battery }} % </b>
                        <small v-if='current_ma<0' class='grey--text text--darken-3'>(Discharging)</small>
                        <small v-else-if='current_ma>0' class='grey--text text--darken-3'>(Charging)</small>
                      </h5>
                      <h5 v-else-if='battery<=75' class='green--text'>
                        <v-icon class='green--text'>mdi-battery-70</v-icon>
                        <b> {{ battery }} % </b>
                        <small v-if='current_ma<0' class='grey--text text--darken-3'>(Discharging)</small>
                        <small v-else-if='current_ma>0' class='grey--text text--darken-3'>(Charging)</small>
                      </h5>
                      <h5 v-else-if='battery<=99' class='light-green--text text--darken-1'>
                        <v-icon class='light-green--text text--darken-1'>mdi-battery-90</v-icon>
                        <b> {{ battery }} % </b>
                        <small v-if='current_ma<0' class='grey--text text--darken-3'>(Discharging)</small>
                        <small v-else-if='current_ma>0' class='grey--text text--darken-3'>(Charging)</small>
                      </h5>
                      <h5 v-else-if='battery==100' class='green--text text--darken-2'>
                        <v-icon class='green--text text--darken-2'>mdi-battery</v-icon>
                        <b> {{ battery }} % </b>
                        <small v-if='current_ma<0' class='grey--text text--darken-3'>(Discharging)</small>
                        <small v-else-if='current_ma>0' class='grey--text text--darken-3'>(Charging)</small>
                      </h5>
                    </v-col>
                  </v-row>
                  <v-row class="ml-1 mr-1 mb-2">
                    <v-col xs="4" class="py-0">
                      <h6><small>Volage</small></h6>
                      <h5>{{ voltage }} <small>V</small></h5>
                    </v-col>
                    <v-col xs="4" class="py-0">
                      <h6><small>Current</small></h6>
                      <h5>{{ Math.abs(current_ma) }} <small>mA</small></h5>
                    </v-col>
                    <v-col xs="4" class="py-0">
                      <h6><small>Power</small></h6>
                      <h5>{{ power }} <small>mW</small></h5>
                    </v-col>
                  </v-row>
                  <v-divider class='mt-0'></v-divider>
                  <v-row class="ml-1 mr-1">
                    <v-col xs="3">
                      <h5><small>CO<sub>2</sub></small></h5>
                      <h4>{{ co2 }} <small>ppm</small></h4>
                    </v-col>
                    <v-col xs="4">
                      <h5><small>O<sub>3</sub></small></h5>
                      <h4>{{ o3 }} <small>ppm</small></h4>
                    </v-col>
                    <v-col xs="4">
                      <h5><small>O<sub>2</sub></small></h5>
                      <h4>{{ o2 }} <small>%</small></h4>
                    </v-col>
                  </v-row>
                  <v-row class="ml-1 mr-1">
                    <v-col xs="4">
                      <h5><small>CO</small></h5>
                      <h4>{{ co }} <small>ppm</small></h4>
                    </v-col>
                    <v-col xs="4">
                      <h5><small>PM2.5</small></h5>
                      <h4>{{ pm2_5 }} <small>μg/m<sup>3</sup></small></h4>
                    </v-col>
                    <v-col xs="4">
                      <h5><small>Temperature</small></h5>
                      <h4>{{ temperature }} <small>°C</small></h4>
                    </v-col>
                  </v-row>
                  <v-row class="ml-1 mr-1">
                    <v-col xs="4">
                      <h5><small>Humidity</small></h5>
                      <h4>{{ humidity }} <small>%</small></h4>
                    </v-col>
                  </v-row>
                  <v-overlay absolute :value="no_response">
                  <v-btn color="error">
                    No response from hardware
                  </v-btn>
                </v-overlay>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>Control</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="control-content">
              <v-card class="p-3">
                <v-overlay absolute :value="loop_flag || loading">
                  <v-btn color="primary">
                    Operating
                    <v-progress-circular
                      indeterminate
                      size="12"
                      class="ma-4"
                    ></v-progress-circular>
                  </v-btn>
                </v-overlay>                
                <!--v-row class="mt-3" no-gutters>
                  <v-col>
                    <v-btn v-if="!capture" class="mx-4 success" @click="clientSetCommand('device_1', 'CAPTURE|1')">
                      Start Capture
                    </v-btn>
                    <v-btn v-if="capture" class="mx-4 warning" @click="clientSetCommand('device_1', 'CAPTURE|0')">
                      Stop Capture
                    </v-btn>
                  </v-col>
                </v-row-->
                <!--v-divider></v-divider-->
                <v-row class="mt-3" no-gutters>
                  <v-col cols="12" class="px-3">
                    <div class="subtitle-1">Graph</div>
                    <v-select
                      v-model="selected_graph"
                      label="Select Graph (Max. of 2)"
                      multiple
                      :items="graphs"
                      item-text="text"
                      item-value="value"
                      chips
                      v-on:input="limiter"
                      hide-details
                    >
                      <template #selection="{ item }">
                        <v-chip color="primary">{{item.text}}</v-chip>
                      </template>
                    </v-select>
                    <v-sheet>
                      <br>
                      <v-checkbox
                        v-model="manual_yaxis"
                        label="Manual Y-axis"
                        hide-details
                        @change="changeYAxis()"
                      >
                      </v-checkbox>
                      <v-expand-transition>
                        <div v-show="manual_yaxis">
                          <v-row class="ml-1 mr-1">
                            <v-col xs="6" class="pb-0">
                              <v-row>
                                <v-text-field
                                  hide-details
                                  type="number"
                                  :disabled="selected_graph[0]==undefined"
                                  v-model="data_1.max"
                                  :label="data_1.label_max"
                                  class="mx-4"
                                >
                                </v-text-field>
                              </v-row>
                              <v-row>
                                  <v-text-field
                                    type="number"
                                    :disabled="selected_graph[0]==undefined"
                                    v-model="data_1.min"
                                    :label="data_1.label_min"
                                    class="mx-4"
                                  >
                                  </v-text-field>
                                </v-row>
                            </v-col>
                            <v-col xs="6" class="pb-0">
                              <v-row>
                                <v-text-field
                                  hide-details
                                    :disabled="selected_graph[1]==undefined"
                                  type="number"
                                  v-model="data_2.max"
                                  :label="data_2.label_max"
                                  class="mx-4"
                                >
                                </v-text-field>
                              </v-row>
                              <v-row>
                                  <v-text-field
                                    hide-details
                                    :disabled="selected_graph[1]==undefined"
                                    type="number"
                                    v-model="data_2.min"
                                    :label="data_2.label_min"
                                    class="mx-4"
                                  >
                                  </v-text-field>
                                </v-row>
                            </v-col>
                          </v-row>
                          <v-btn class='btn' color='green lighten-1' dark @click="changeYAxis()">Apply Y-axis</v-btn>                      
                        </div>
                      </v-expand-transition>
                      <br>
                    </v-sheet>
                  </v-col>
                  <v-col cols="12">
                    <v-divider></v-divider>
                    <v-btn class="mx-4 my-2" @click="downloadZipExperimentData('device_1')" color="primary">
                      Export All Data
                    </v-btn>
                    <v-btn class="mx-4 my-2" @click="clearCapture" color="error">
                      Clear Graph
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <v-col xs="12" sm="8">
        <v-expansion-panels v-model="controlPanel2" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header color="green lighten-5">
              <h5>Measure Result</h5>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <apexchart
                v-if="$i18n.locale=='tc'"
                type="line"
                :options="options_chi"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              <apexchart
                v-else
                type="line"
                :options="options"
                :series="series"
                ref="realtimeChart"
              >
              </apexchart>
              <v-overlay absolute :value="loop_flag || loading">
                <v-btn color="primary">
                  Operating
                  <v-progress-circular
                    indeterminate
                    size="12"
                    class="ma-4"
                  ></v-progress-circular>
                </v-btn>
              </v-overlay>
            </v-expansion-panel-content>            
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog_lab_manual" max-width="700px" >
      <v-card class="pb-3">
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeLabManualDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.lab_manual.header") }}</v-toolbar-title>
        </v-toolbar>
        <v-row justify="center" no-gutters>
          <v-col cols="11"  class="my-2 px-1">
            <v-row>              
              <v-col cols="12">
                <div v-if="lab_manual.school_chi.path!=null || lab_manual.school_en.path!=null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.school_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_en.path" target="_BLANK">{{ lab_manual.school_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.school_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.school_chi.path" target="_BLANK">{{ lab_manual.school_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
                <div v-else-if="lab_manual.school_chi.path==null && lab_manual.school_en.path==null">
                  <v-card class="p-1">
                    <v-card-text class="p-1">
                      <v-row>
                        <v-col class="" cols="12">
                          <div v-if="lab_manual.suggested_en.path!=null">
                            <v-icon class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_en.path" target="_BLANK">{{ lab_manual.suggested_en.filename }} {{ $t("experiment.fab.dialog.lab_manual.en_label") }}</a>
                          </div>
                          <div v-if="lab_manual.suggested_chi.path!=null">
                            <v-icon  class="p-1" color="primary">mdi-file-document-outline</v-icon><a :href="lab_manual.suggested_chi.path" target="_BLANK">{{ lab_manual.suggested_chi.filename }} {{ $t("experiment.fab.dialog.lab_manual.chi_label") }}</a>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_setup" max-width="800px">
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="closeSetupDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("experiment.fab.dialog.setup_photo.header") }}</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <v-carousel v-model="model" height="auto">
          <v-carousel-item
            v-for="(item,i) in setup_photos"
            :key="i"
            :src="item.src"
          >
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ExperimentTitle from "@/components/ExperimentTitle.vue";
import ExperimentBasic from "@/services/iot/api_basic_experiment";
export default {
  name: "air_monitoring",
  components: {
    ExperimentTitle,
  },
  mixins: [ExperimentBasic],
  data: function () {
    return {
      controlAuth: true,
      model: 0,
      dialog_setup: false,
      dialog_lab_manual: false,
      checkEnd: true,
      direction: 'bottom',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: true,
      right: true,
      bottom: false,
      left: false,
      transition: 'slide-y-reverse-transition',
      current: {
        username: null,
        user_level: "USER",
        school_id: null,
        auth_token: null,
        experiment: null,
        equipment_id: null,
        booking_id: null,
      },
      controlPanel: [0, 1],
      controlPanel2: [0],
      realTimePanel: 0,
      stored_data: [["Time", "CO2", "O3", "O2", "CO", "PM2.5", "Temperature", "Humidity"]],
      is_capturing: false,
      capture: 0,
      timer: 0,
      time_now: null,
      counter: 0,
      realtime_interval: null,
      loop_interval: 10000,
      mounted_interval_1: null,
      no_response: 1,
      selected_graph: "",
      graph_units: {"CO2":"ppm", "O3": "ppm", "O2": "%", "CO": "ppm", "PM2_5": "μg/m³", "Temp": "°C", "Humidity": "%"},
      graph_names: {"CO2":"CO₂", "O3": "O₃", "O2": "O₂", "CO": "CO", "PM2_5": "PM2.5", "Temp": "Temperature", "Humidity": "Humidity"},
      graphs: [
        {"value": "CO2", "text": "CO₂"},
        {"value": "O3", "text": "O₃"},
        {"value": "O2", "text": "O₂"},
        {"value": "CO", "text": "CO"},
        {"value": "PM2_5", "text": "PM2.5"},
        {"value": "Temp", "text": "Temperature"},
        {"value": "Humidity", "text": "Humidity"}
      ],
      data_1: {
        data_max: undefined,
        data_min: undefined,
        max: undefined,
        min: undefined,
        label_max: "",
        label_min: ""
      },
      data_2: {
        data_max: undefined,
        data_min: undefined,
        max: undefined,
        min: undefined,
        label_max: "",
        label_min: ""
      },
      yaxis_apply: true,
      manual_yaxis: false,
      battery: 100,
      voltage: 0,
      current_ma: 0,
      power: 0,
      co2: 0,
      o3: 0,
      o2: 0,
      co: 0,
      pm2_5: 0,
      temperature: 0, 
      humidity: 0,
      temperature_1: 0,
      temperature_2: 0,
      step_status: "",
      loading: false,
      loop_flag: false,
      setup_photos: [],
      lab_manual:{
        school_chi: { path: null, filename: null },
        school_en: { path: null, filename: null },
        suggested_chi: { path: null, filename: null },
        suggested_en: { path: null, filename: null },
      },
      api: {
        value: "",
        value_got_at: null,
        value_set_at: null,
      },      
      options: {
        colors: ["#FF0000", "#0000FF"],
        width: "100%",
        stroke: {
          width: 1,
        },

        yaxis: {
          title: {
            text: "Temperature (°C)",
          },
        },
        xaxis: {
          labels: {
            show: false,
            hideOverlappingLabels: true,
          },
          title: {
            text: "Time (s)",
            offsetY: 10,
          },
        },
      },      
      options_chi: {
        width: "100%",
        stroke: {
          width: 1,
        },yaxis: {
          title: {
            text: "溫度 (°C)",
          },
        },
        xaxis: {
          labels: {
            show: false,
            hideOverlappingLabels: true,
          },
          title: {
            text: "時間 (s)",
          },
        },
      },
      series: [
        {
          name: "Set 1",
          data: [],
        },
        {
          name: "Set 2",
          data: [],
        },
      ],
    };
  },
  mounted: function () {    
    var self = this;
    self.checkEnd = self.$parent.checkEnd;
    self.current.school_id = self.$store.state.user.school_id;
    self.current.username = self.$store.state.user.username;
    self.current.user_level = self.$store.state.user.user_level;
    self.current.auth_token = self.$store.state.user.auth_token;
    self.school_id = self.$route.params.school_id;
    self.experiment = self.$route.query.experiment;
    self.equipment_id = self.$route.query.equipment;
    self.getValue("device_1", function () {
      self.battery = self.api.value.Battery,
      self.voltage = self.api.value.Voltage,
      self.current_ma = self.api.value.Current,
      self.power = self.api.value.Power,
      self.co2 = self.api.value.CO2,
      self.o3= self.api.value.O3, 
      self.o2 = self.api.value.O2,
      self.co = self.api.value.CO,
      self.pm2_5 = self.api.value["PM2.5"],
      self.temperature = self.api.value.Temp,
      self.humidity = self.api.value.Humidity,
      self.capture = self.api.value.capture;      
      self.time_now = Date.now()/1000;
      if(self.time_now-self.api.value_set_at > 10) {
        self.no_response = true;
        self.clearRealtimeInterval()
      }
      else {
        self.no_response = false;
        self.startRealtimeInterval();
      }
    });

    self.checkOverrided();

    self.mounted_interval_1 = setInterval(function () {
      self.getValue("device_1", function () {
        self.time_now = Date.now()/1000;
        if(self.time_now-self.api.value_set_at > 10) {
          self.no_response = true;
          self.clearRealtimeInterval();
        }
        else {
          self.no_response = false;
          self.clearRealtimeInterval();
          self.startRealtimeInterval();
          self.getChartMultiple("device_1", self.selected_graph.length, self.selected_graph[0], self.selected_graph[1]);
        }
      });
    }, 10000);
    
    self.experiment_name = "AIR_MONITORING";
  },
  methods: {    
    openLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = true;
    },
    closeLabManualDialog(){
      var self = this;
      self.dialog_lab_manual = false;
    },
    openSetupDialog(){
      var self = this;
      self.dialog_setup = true;
    },
    closeSetupDialog(){
      var self = this;
      self.dialog_setup = false;
    },
    changeCheck(){
      var self = this;
      self.$emit("changeCheck");
      self.checkEnd = self.$parent.checkEnd;
    },
    changeYAxis(){
      var self = this;
      self.applyManualYAxis("multiple", self.selected_graph.length);
    },
    clearCapture: function () {
      var self = this;
      //if(self.capture==1){
      //  alert("Please stop capture before clearing graph.");
      //}
      //else {
        var r = confirm("Are you sure to clear the graph? Please make sure setup has stopped capturing.");
        if (r == true) {
          self.clearChartMultiple("device_1", 7, ['CO2','O2','O3','CO','PM2_5','Temp','Humidity']);
        }
      //}
    },
    startRealtimeInterval(){
      var self = this;
      self.realtime_interval = setInterval(function () {
        self.getValue("device_1", function () {
          self.battery = self.api.value.Battery,
          self.voltage = self.api.value.Voltage,
          self.current_ma = self.api.value.Current,
          self.power = self.api.value.Power,
          self.co2 = self.api.value.CO2,
          self.o3= self.api.value.O3, 
          self.o2 = self.api.value.O2,
          self.co = self.api.value.CO,
          self.pm2_5 = self.api.value["PM2.5"],
          self.temperature = self.api.value.Temp,
          self.humidity = self.api.value.Humidity,
          self.capture = self.api.value.capture;
        });
      }, 2000);
    },
    clearRealtimeInterval(){
      var self = this;
      clearInterval(self.realtime_interval);
    },
    limiter(e) {
      var self = this;
      if(e.length > 2) {
        e.pop();
      }
      if(e.length ==2){
        self.getChartMultiple("device_1", 2, e[0], e[1]);
        
        self.data_1.label_max = self.graph_names[e[0]] + " Max";
        self.data_1.label_min = self.graph_names[e[0]] + " Min";
        
        self.data_2.label_max = self.graph_names[e[1]] + " Max";
        self.data_2.label_min = self.graph_names[e[1]] + " Min";
      }
      else if(e.length==1){
        self.getChartMultiple("device_1", 1, e[0]);
        self.data_1.label_max = self.graph_names[e[0]] + " Max";
        self.data_1.label_min = self.graph_names[e[0]] + " Min";
      }
    },
  },
  beforeDestroy() {
    if (this.$refs.camera1Image) {
      this.$refs.camera1Image.src = '';
    }
    if (this.$refs.camera2Image) {
      this.$refs.camera2Image.src = '';
    }
  },
  destroyed() {
    clearInterval(this.mounted_interval_1);
    this.clearRealtimeInterval();
  }
};
</script>
<style>
  /* This is for documentation purposes and will not be needed in your application */
  .v-speed-dial {
    position: absolute;
    z-index: 2;
  }

  .v-btn--floating {
    position: relative;
    z-index: 5;
  }
  
  .control-content>.v-expansion-panel-content__wrap{
    padding: 0;
  }
</style>
